const bmsUserIds = [2140290]
const jfsUserIds = [1689773, 2162686]

//  2140290 - book my show
// 1063768 - durgesh staging
// 1689773  - jfs staging
// 2162686 - jfs production

const bmsRedirectionLink = 'https://in.bookmyshow.com/'

export { bmsRedirectionLink, bmsUserIds, jfsUserIds }
